

























































































































































































































import { fetchDespacho } from './fetchDespacho';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import moment from 'moment';
import Vue from 'vue';
import { AxiosVue } from '@/AxiosVue'; //
import { ServicioProxy } from '@/config/enums'; //
import config from '@/config/index'; //
import { ComponenteBaseStepper } from '../../views/base/ComponenteBaseStepper';
import { Component, Prop, Emit, Watch } from 'vue-property-decorator';

import { LoadingService } from '@/services/loadingService';

import { Validator } from 'vee-validate';
import { PermisoAccionVm } from '@/views/base/PermisoAccionVm';
import { Funcionalidades } from '@/config/funcionalidades';
import { CodigoAccion } from '@/views/base/VariablesPermisos';
import { IFuncionalidad } from '@/interfaces/Funcionalidad';
import { AccionesInterface, IAccionesPadre } from '@/interfaces/Acciones';
const { AgGridVue } = require('ag-grid-vue');
import {
  GridApi,
  ColumnApi,
  ColDef,
  CellContextMenuEvent,
  GridReadyEvent,
  SelectionChangedEvent,
  SelectionController,
  RowNode,
  CellClickedEvent,
  RowSelectedEvent,
  CellClassParams,
} from 'ag-grid-community';
import { differenceBy } from 'lodash';
import Confirmation from '@/components/Confirmation.vue'; //
import { SubAccion } from '../../views/base/VariablesPermisos';

@Component({
  components: {
    DatePicker,
    'ag-grid-vue': AgGridVue,
    'app-confirmacion': Confirmation,
  },
})
export default class FormCrearDespacho extends ComponenteBaseStepper {
  @Prop({ required: true }) nuevoCodigo: number;
  @Prop({ required: true }) usuarioActivo: any;
  @Prop({ default: false }) coordinadorList!: any;
  @Prop({ default: false }) courrierList!: any;
  @Prop({ default: false }) localidadList!: any;

  @Prop({ default: false }) show: boolean;
  tecnicoList: any = [];
  async getTecnico() {
    this.tecnicoList = [];
    let self = this;
    this.loadingService.showLoading();
    return fetchDespacho(
      {
        locaid: this.formFields.localidad.value,
      },
      'conectaDespacho/get_tecnico'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          this.tecnicoList = data.data.data.LISTA;
          return;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }

  formFields: {
    fechaEnvio: any;
    usuario: any;
    curier: any;
    ordenSeguimiento: any;
    localidad: any;
    coordinador: any;
    tecnico: any;
    observacion: any;
    costo: any;
    valor: any;
    fechaRecepcion: any;
    receptor: any;
    nuevoCodigo: any;
  } = {
    nuevoCodigo: {
      label: 'Código',
      value: 'Por asignar',
    },
    fechaEnvio: {
      label: 'Fecha Envio',
      value: moment(),
      selectedValue: '',
    },
    usuario: {
      label: 'Usuario',
      value: this.usuarioActivo.nombre,
    },
    curier: {
      label: 'Courier',
      value: null,
    },
    ordenSeguimiento: {
      label: 'Orden de Seguimiento (Obligatorio)',
      value: '',
    },
    localidad: {
      label: 'Localidad (Obligatorio)',
      id: '',
      value: '',
    },
    coordinador: {
      label: 'Coordinador (Obligatorio)',
      id: 'coorid',
      value: '',
    },
    tecnico: {
      label: 'Técnico (Obligatorio)',
      id: 'tecnicoid',
      value: '',
    },
    observacion: {
      label: 'Observación',
      value: '',
    },
    costo: {
      label: 'Costo',
      value: false,
    },
    valor: {
      label: 'Valor',
      value: '',
    },
    fechaRecepcion: {
      label: 'Fecha Recepción',
      value: '',
      selectedValue: '',
    },
    receptor: {
      label: 'Receptor',
      value: '',
    },
  };

  async validarOrden(): Promise<boolean> {
    let self = this;
    return fetchDespacho(
      {
        seguimiento: this.nuevoDato.ordenSeguimiento,
        courrier: this.nuevoDato.curier,
      },
      'conectaDespacho/validar_orden'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          return data.data.data.despaseguimiento_exists == 't';
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          return false;
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Error al crear el despacho', { timeout: 3000 });
        return false;
      });
    /*.finally(() => {
        return null;
      });  */
  }

  async crearDespa() {
    let self = this;
    if (
      this.nuevoDato.ordenSeguimiento != '' &&
      this.nuevoDato.localidad != '' &&
      this.nuevoDato.coordinador != '' &&
      this.nuevoDato.tecnico != ''
    ) {
      let validar = await this.validarOrden();
      if (validar) {
        self.$snotify.error(
          'La Orden de Seguimiento se encuentra duplicada con ese Courier',
          { timeout: 3000 }
        );
        return;
      }
      return fetchDespacho(
        {
          despaAnterior: this.nuevoCodigo,
          despanumero: this.nuevoDato.codigo,
          fechaEnvio: this.nuevoDato.fechaEnvio,
          usuario: this.nuevoDato.usuario,
          rut: this.nuevoDato.rut,
          curier: this.nuevoDato.curier,
          ordenSeguimiento: this.nuevoDato.ordenSeguimiento,
          localidad: this.nuevoDato.localidad,
          coordinador: this.nuevoDato.coordinador,
          tecnico: this.nuevoDato.tecnico,
          observacion: this.nuevoDato.observacion,
          costo: this.nuevoDato.costo,
          valor: this.nuevoDato.valor,
          fechaRecepcion: this.nuevoDato.fechaRecepcion,
          receptor: this.nuevoDato.receptor,
        },
        'conectaDespacho/crear'
      )
        .then((data: any) => {
          if (data.data.CODIGO_RESPUESTA == '1') {
            self.$snotify.success(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
            this.closeModal(false);
            //this.nuevoCodigo= this.nuevoCodigo+1
            return null;
          } else {
            self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
            return [];
          }
        })
        .catch((error: any) => {
          self.$snotify.error('Error al crear el despacho', { timeout: 3000 });
        });
      /*.finally(() => {
        return null;
      });  */
    } else {
      self.$snotify.error('Por favor ingrese todos los campos obligatorios', {
        timeout: 3000,
      });
    }
  }

  nuevoDato: any = {};

  crear() {
    let localidadSelected = {
      locaid: ' ',
    };

    localidadSelected =
      this.formFields.localidad.value != ' '
        ? this.localidadList.find(
            (e: any) => e.locaid == this.formFields.localidad.value
          )
        : '';

    this.nuevoDato = {
      codigo: this.nuevoCodigo,
      fechaEnvio:
        this.formFields.fechaEnvio.value != ''
          ? moment(this.formFields.fechaEnvio.value).format('YYYY-MM-DD')
          : '',
      usuario: this.usuarioActivo.id,
      rut: this.usuarioActivo.rut,
      curier:
        this.formFields.curier.value !== null
          ? this.formFields.curier.value
          : null,
      ordenSeguimiento: this.formFields.ordenSeguimiento.value,
      localidad:
        localidadSelected && localidadSelected.locaid
          ? localidadSelected.locaid
          : '',
      coordinador: this.formFields.coordinador.value || '',
      tecnico: this.formFields.tecnico.value || '',
      observacion: this.formFields.observacion.value,
      costo: this.formFields.costo.value ? '1' : '0',
      valor: this.formFields.valor.value,
      fechaRecepcion:
        this.formFields.fechaRecepcion.value != ''
          ? moment(this.formFields.fechaRecepcion.value).format('YYYY-MM-DD')
          : '',
      receptor: this.formFields.receptor.value,
    };
    this.crearDespa();
  }

  // permisos
  permisosActuales: PermisoAccionVm[] = [];

  // Declarar todas las posibles subAcciones
  crearDespacho: PermisoAccionVm = {
    accion: 'Crear - Crear Despacho',
    visible: true,
    step: 1,
    codigoAccionPadre: CodigoAccion.Crear,
    codigoSubAccion: 19,
  };

  asociarAcciones: PermisoAccionVm = {
    accion: 'Crear - Asociar Acciones',
    visible: true,
    step: 1,
    codigoAccionPadre: CodigoAccion.Crear,
    codigoSubAccion: 20,
  };

  asociarSubAcciones: PermisoAccionVm = {
    accion: 'Crear - Asociar SubAcciones',
    visible: true,
    step: 1,
    codigoAccionPadre: CodigoAccion.Crear,
    codigoSubAccion: 21,
  };

  permisosTotales: PermisoAccionVm[] = [
    this.crearDespacho,
    this.asociarAcciones,
    this.asociarSubAcciones,
  ];

  // Globales
  $snotify: any;
  e1: number = 1;
  btnText: string = 'Continuar';
  btnClass: string = 'btn-continuar';
  dialog: boolean = true;
  validForm: boolean = false;
  clienteId: number = config.getClienteSesion();
  loadingService = new LoadingService();
  btnBloquear: boolean = false;
  dialogConfirmacion: boolean = false;
  dialogConfirmacionClose: boolean = false;

  estadoSeleccionado: any = null;
  AccionesAsignados: AccionesInterface[] = [];
  //Interface
  editedItem: IFuncionalidad = {};

  //controllers
  readonly controller: string = 'funcionalidad';
  readonly controllerAccion: string = 'accion';
  readonly controllerModuloAccion: string = 'ModuloAccion';
  axios: AxiosVue = new AxiosVue(ServicioProxy.GestionUsuario);

  //@Watch('show')

  closeModal(val: boolean) {
    document.getElementById('cardDivModulos').scrollIntoView(true);
    this.editedItem = {};
    this.e1 = 1;
    this.$emit('datoCreado', true);
    this.$emit('modalAsociacionEmit', false);
    //Reset Validaciones
    this.dialog = false;
    this.btnText = 'Continuar';
    this.btnClass = 'btn-continuar';
    this.show = false;
  }

  confirmCallbackConfirm(val: boolean) {
    this.dialogConfirmacionClose = false;
    if (val) {
      this.closeModal(false);
    }
  }

  cierraMenu() {
    var appBanners = document.getElementsByClassName(
      'ag-menu'
    ) as HTMLCollectionOf<HTMLElement>;
    if (appBanners.length > 0) {
      appBanners[0].remove();
    }
  }
}
